import React, {Component} from 'react'
import LogIn from '../LogIn/LogIn';
import irates from '../../data/iprefer';
import RateDetailsPop from '../Rate/RateDetailsPop';
import MiniSlideshowGeneric from '../MiniSlideshow/MiniSlideshowGeneric';
import { withRouter } from "react-router-dom";
import parse from 'html-react-parser';



class SingleExtra extends Component{

  state={
      product: false,
  }


  componentDidMount(){
      
      if(this.state.product === false && this.props.product === false){
        let url = window.location.href;
        let id = url.substring(url.lastIndexOf('/') + 1);
        // console.log(id);

        
        // DEV
        fetch(`${process.env.REACT_APP_BACK}/api/guest-portal-extras/?id=${id}`)
        .then(response => response.json())
        .then(response => {
          this.setState({ product : response[0] });
          
        })
        .catch(err => console.error(err));
      }else{
        this.setState({product : this.props.product });
      }

  }

  handleFormChange = (e) => {
      let form = document.getElementById('extra-form');
      let formData = new FormData(form);
      let formValues = {};
      formData.forEach((value, key) => {
        formValues[key] = value;
      });
      console.log(formValues);
  }

  handleQtyChange = (e) => {
    let qty = document.getElementsByName('qty')[0];
    let qtyValue = parseInt(qty.value);
    qtyValue = !Number.isInteger(qtyValue) ? 0 : qtyValue;
    if(e.target.innerHTML === '−'){
      if(qtyValue > 1){
        qtyValue = qtyValue - 1;
      }
    }else{
      qtyValue = qtyValue + 1;
    }
    qty.value = qtyValue;
    this.handleFormChange(e);
  }
  
  render(){
    // console.log();
    if(this.state.product === false){
      return (<small>Loading</small>);
    }else{
    // window.scrollTo(0,0);
    return (
      <>
        

        <div className='single-extra'>
            <div className=''>
                <div className='slider-container'>
                  <MiniSlideshowGeneric feat={this.state.product.feat} gallery={this.state.product.gallery} />
                </div>
                <br/>

                <div className='flex layout-60-40'>
                  <div>
                    <div className='pad-y-2'>
                <h1 className=''>{this.state.product.name}</h1>
                <p>Exciting attractions and experiences tailored to your interests and travel preferences.</p>
            </div>
                    {parse(this.state.product.body)}
                  </div>
              
                  <div >
                    <div className='holder'>
                      <div id="extra-form-container">
                        <form id="extra-form" onChange={(e)=>{this.handleFormChange(e)}}>
                          <div id="value">{this.state.product.amount}</div>
                          <div>
                            <label>Quantity</label>
                            <div className='flex flex-walls flex-y-center'>
                              <input type="number" name="qty" defaultValue="1" />
                              <div className='flex'>
                                <span className="qty" onClick={(e)=>{this.handleQtyChange(e)}}>−</span>
                                <span className="qty" onClick={(e)=>{this.handleQtyChange(e)}}>+</span>
                              </div>
                            </div>
                          </div>
                          <button type="button" class="btn-book"><a>Add to cart</a></button>
                        </form>
                      </div>
                    </div>
                  </div>

                </div>
                <br/>
                

            </div>
            <div>
            </div>
        </div>
      </>
    );
    }
  }
}




export default SingleExtra